  <template lang="pug">
  v-dialog(v-model="dialogMoreInsurances" fullscreen hide-overlay transition='dialog-bottom-transition')
    v-card
      v-card-text#header-inside-more-insurances
        v-layout(class="header" row wrap)
          v-flex.container--logo(xs6 sm6 md4 lg4)
            router-link(target="_self" :to="'/inicio'")
              img(src="@/assets/logo.svg" srcset="@/assets/logo.svg" alt="Logo")
          v-flex.container--logout(xs6 sm6 md6 lg6)
            a.logout.omnesRegular(href="#" v-on:click="logout($event)") Cerrar Sesión
        v-layout(row wrap)
          v-flex.title-insurances(xs12)
            img(:src='iconProduct' width="35%")
            h1 MÁS SEGUROS
            v-btn#btn__close(icon dark @click.native="hideDialog()")
              v-icon close
          v-flex.container-more-insurances(xs12)
            v-layout
              v-flex(xs6 @click="openNewWindow('https://www.interseguro.pe/segurodevida/universitario/', 'Seguro Universitario')")
                img(:src='iconSeguroUniversitario' width="35%")
                p Seguro Universitario
              v-flex(xs6 @click="openNewWindow('https://www.interseguro.pe/segurodevida/ahorrojubilacion/', 'Ahorro Seguro')")
                img(:src='iconAhorroJubilacion' width="35%")
                p Ahorro Jubilación
            v-layout
              v-flex(xs6 @click="openNewWindow('https://www.interseguro.pe/segurodevida/protecciontotal/', 'Protección Segura')")
                img(:src='iconProteccionTotal' width="35%")
                p Protección Segura
              v-flex(xs6 @click="openNewWindow('https://www.interseguro.pe/vehicular/', 'Vehicular')")
                img(:src='iconVehicular' width="35%")
                p Vehicular
            v-layout
              v-flex(xs6 @click="openNewWindow('https://www.interseguro.pe/soat/', 'SOAT')")
                img(:src='iconSoat' width="35%")
                p Soat Electrónico
              v-flex(xs6 @click="openNewWindow('https://www.interseguro.pe/vidacash/', 'Vida con Devolución')")
                img(:src='iconVidaCash' width="35%")
                p  Vida con Devolución
</template>

<script>
export default {
  props: ['dialogMoreInsurances'],
  data () {
    return {
      iconProduct: require('./../../assets/icons/icon-productos.svg'),
      iconEducacion: require('./../../assets/icons/icon-educacion.svg'),
      iconJubilacionSegura: require('./../../assets/icons/icon-jubilacion_segura.svg'),
      iconRenta: require('./../../assets/icons/icon-renta.svg'),
      iconSoat: require('./../../assets/icons/icon-soat.svg'),
      iconVehicular: require('./../../assets/icons/icon-vehicular.svg'),
      iconVidaCash: require('./../../assets/icons/icon-vidacash.svg'),
      iconSeguroUniversitario: require('./../../assets/icons/icon-su.svg'),
      iconProteccionTotal: require('./../../assets/icons/icon-pt.svg'),
      iconAhorroJubilacion: require('./../../assets/icons/icon-js.svg'),
      amplitude: {
        events: {
          moreInsuranceInterest: 'Más seguros de interes'
        }
      }
    }
  },
  methods: {
    hideDialog () {
      document.body.removeAttribute('class', 'noscroll')
      this.$root.$emit('closeMoreInsurances', {})
      this.$root.$emit('enableIconHome', {})
    },
    openNewWindow (url, amplitude) {
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.moreInsuranceInterest,
          {
            'Seguro de interés': amplitude
          }
        )
      window.open(url, '_blank')
    },
    logout (evt) {
      evt.preventDefault()
      sessionStorage.removeItem('infoPoliza')
      if (localStorage.removeItem('jwt') !== null) {
        this.$store.state.user.session = null
        this.$store.state.user.jwt = null
        this.$store.state.user.coUs = null
        this.$store.state.user.info = null
        this.$store.state.user.user = null
        this.$store.state.user.polizas = null
        this.$store.state.user.historyPayments = null
        localStorage.removeItem('products')
        this.$router.push('/')
      }
    }
  }
}
</script>

<style>
  .container-more-insurances{ background-color: #F6F6F6 }
  .container-more-insurances .layout {
    margin-bottom: 10px;
  }
  .container-more-insurances .layout .flex {
    text-align: center;
    background-color: #FFF;
    padding-top: 16px;
  }
  .container-more-insurances .layout .flex:first-child {
    margin-left: 16px;
    margin-right: 5px;
  }
  .container-more-insurances .layout .flex:last-child {
    margin-right: 16px;
    margin-left: 5px;
  }
  .container-more-insurances .layout .flex p { font-size: 16px; }
  #header-inside-more-insurances .layout.header {
    background-color: #0855C4;
    padding: 1.3em 16px 0.7em 16px;
  }
  #header-inside-more-insurances .layout.header .flex.container--logout {
    padding-top: 6px;
  }
  /* Small to large handset ----------- */
  @media only screen and (max-width : 600px) {
    #header-inside-more-insurances {
      height: calc(100vh - 113px);
      overflow-y: scroll;
    }
  }
  /* iPhone 6, 7, & 8 in portrait & landscape ----------- */
  @media only screen and (min-device-width: 375px) and (max-device-width: 667px) {
    #header-inside-more-insurances {
      height: calc(100vh - 136px);
      overflow-y: scroll;
    }
  }
  /* iPhone X in portrait & landscape ----------- */
  @media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-device-pixel-ratio: 3) {
    #header-inside-more-insurances {
      height: calc(100vh - 173px);
      overflow-y: scroll;
    }
  }
  /* iPhone XR in portrait & landscape ----------- */
  @media only screen and (device-width : 414px) and (device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
    #header-inside-more-insurances {
      height: calc(100vh - 173px);
      overflow-y: scroll;
    }
  }
  /* ----------- Galaxy Phones ----------- */
  /* Portrait and Landscape */
  @media screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 192dpi) and (max-width: 640px) {
    #header-inside-more-insurances {
      height: calc(100vh - 117px);
      overflow-y: scroll;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/DialogMoreInsurances.vue